export default class Pagination {
  constructor() {
    this.paginationContainer = document.querySelector('.pagination');
    this.container = document.querySelector('.js-pagination-container');
    this.button_previous = document.querySelector('.js-pagination-prev');
    this.button_next = document.querySelector('.js-pagination-next');
    this.current_page = 1;
    this.num_pages = 0;
  }

  update() {
    if (this.num_pages <= 1) {
      this.paginationContainer.style.display = 'none';
      return;
    } 

    this.clear();

    var pagination_indexes = this.getIndexes();

    if(this.current_page == 1) {
      this.button_previous.disabled = true;
    } else {
      this.button_previous.disabled = false;
    }

    if(this.current_page == this.num_pages) {
      this.button_next.disabled = true;
    } else {
      this.button_next.disabled = false;
    }

    pagination_indexes.forEach((index) => {
      if(index == "...") {
        this.container.innerHTML += '<li class="pagination__item --dots js-pagination-item" data-page="">....</li>';
      } else {
        this.container.innerHTML += '<li class="pagination__item js-pagination-item ' + (index == this.current_page ? "--active" : "") + '" data-page="' + index + '">' + index + '</li>';
      }
    });
  }

  getIndexes() {
    var pagination_values = [];
    if(this.num_pages <= 6) {
      for(var i = 1; i <= this.num_pages; i++) {
        pagination_values.push(i);
      }
    } else if(this.current_page + 5 < this.num_pages) {
      pagination_values.push(this.current_page);
      pagination_values.push(this.current_page + 1);
      pagination_values.push(this.current_page + 2);
      pagination_values.push("...");
      pagination_values.push(this.num_pages - 2);
      pagination_values.push(this.num_pages - 1);
      pagination_values.push(this.num_pages);
    } else {
      for(var i = this.num_pages; i >= this.num_pages - 5; i--) {
        pagination_values.unshift(i);
      }
      pagination_values.unshift("...");
    }

    return pagination_values;
  }

  clear() {
    this.button_previous.disabled = true;
    this.button_next.disabled = true;
    this.container.innerHTML = "";
  }
}
